// AI Generated Component
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UserLocaleService } from '@monsido/core/locale/services/locale.service';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';

@Component({
    selector: 'form-user-basic',
    templateUrl: './basic.component.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FormUserBasicComponent implements OnInit {
    @Input() user: any;
    @ViewChild('userFormBasicFieldset') userFormBasicFieldset?: FormGroup;

    localeOptions: any[] = [];

    constructor (
        private userLocaleService: UserLocaleService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        // This is not the correct place for languages. But we only have two languages so it's a easy fix!
        this.localeOptions = this.userLocaleService.getLocaleOptions();
        this.user.locale = this.user.locale || 'en';
        if (!this.user.email_notifications) {
            this.user.email_notifications = {
                exports: false,
            };
        }
    }

    passwordMatchCheck () {
        if (this.user.password !== this.user.password_confirmation) {
            this.userFormBasicFieldset?.controls['password'].setErrors({ passwordMismatch: true });
            this.userFormBasicFieldset?.controls['password_confirmation'].setErrors({ passwordMismatch: true });
        }
    }
}
